import { render, staticRenderFns } from "./SavedListSummary.vue?vue&type=template&id=087a4305&"
import script from "./SavedListSummary.vue?vue&type=script&lang=js&"
export * from "./SavedListSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports